import React from 'react';
import { motion } from 'framer-motion';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';

const reviews = [
    {
        name: 'Ahmet Y.',
        role: '12. Sınıf Öğrencisi',
        comment: 'YKS sürecinde en büyük yardımcım oldu. Özellikle akıllı tekrar sistemi harika!',
        stars: 5,
    },
    {
        name: 'Ayşe K.',
        role: 'Mezun',
        comment: 'Offline çalışabilmesi kütüphanede internet derdini bitirdi. Teşekkürler Soruly!',
        stars: 5,
    },
    {
        name: 'Oğuzhan K.',
        role: 'Mezun',
        comment: 'Analizler sayesinde hangi konuda eksiğim olduğunu hemen görüyorum.',
        stars: 5,
    },
    {
        name: 'Zeynep S.',
        role: 'Eşit Ağırlık',
        comment: 'Tasarımı çok şık ve göz yormuyor. Gece modu favorim.',
        stars: 4,
    },
    {
        name: 'Can B.',
        role: '11. Sınıf',
        comment: 'Yapay zeka asistanı sayesinde günlük yaptıklarım kalıcı hale geliyor.',
        stars: 5,
    },
    {
        name: 'Elif N.',
        role: 'Mezun',
        comment: 'Pomodoro sayacı ile çalışma sürelerimi çok daha iyi yönetiyorum.',
        stars: 5,
    },
];

const Reviews = () => {
    return (
        <section className="section reviews-section">
            <div className="container">
                <div className="section-header">
                    <motion.h2
                        className="section-title"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5 }}
                    >
                        Kullanıcı Yorumları
                    </motion.h2>
                    <motion.p
                        className="section-subtitle"
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        Binlerce öğrenci Soruly ile hedeflerine ulaşıyor.
                    </motion.p>
                </div>
            </div>

            <div className="reviews-marquee-container">
                <motion.div
                    className="reviews-track"
                    animate={{ x: [0, -1000] }}
                    transition={{
                        x: {
                            repeat: Infinity,
                            repeatType: "loop",
                            duration: 20,
                            ease: "linear",
                        },
                    }}
                >
                    {[...reviews, ...reviews].map((review, index) => (
                        <div className="review-card" key={index}>
                            <div className="review-header">
                                <div className="review-stars">
                                    {[...Array(review.stars)].map((_, i) => (
                                        <FaStar key={i} className="star-icon" />
                                    ))}
                                </div>
                                <FaQuoteLeft className="quote-icon" />
                            </div>
                            <p className="review-comment">{review.comment}</p>
                            <div className="review-author">
                                <div className="author-avatar">
                                    {review.name.charAt(0)}
                                </div>
                                <div className="author-info">
                                    <span className="author-name">{review.name}</span>
                                    <span className="author-role">{review.role}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </motion.div>
            </div>
        </section>
    );
};

export default Reviews;
